export const isNoneEnum = {
  NONE: 'NONE',
  NOT_NONE: 'NOT_NONE',
} as const

export type IsNoneEnum = (typeof isNoneEnum)[keyof typeof isNoneEnum]

export type IsNone = IsNoneEnum